<template>
  <aside class="app-sidebar">
    <div class="app-sidebar-top">
      <nav class="app-sidebar-nav">
        <router-link
          v-for="item in items"
          :key="item.name"
          class="app-sidebar-link"
          :class="{ 'is-active': isActive(item) }"
          :to="{ name: item.name }"
          :title="item.label"
        >
          <span class="app-sidebar-icon">
            <img class="app-sidebar-icon-image" :src="item.icon" :alt="item.label">
          </span>
          <span class="app-sidebar-text">{{ item.label }}</span>
        </router-link>
      </nav>
    </div>
  </aside>
</template>

<script>
var SIDEBAR_ITEMS = [
  { name: "home", label: "首页", icon: "/image/home.png" },
  { name: "plaza", label: "广场", icon: "/image/ground.png" },
  { name: "chat-text", label: "文本", icon: "/image/text.png" },
  { name: "chat-picture", label: "图片", icon: "/image/image.png" },
  { name: "chat-video", label: "视频", icon: "/image/video.png" }
];

export default {
  name: "AppSidebar",
  computed: {
    items: function items() {
      return SIDEBAR_ITEMS;
    }
  },
  methods: {
    isActive: function isActive(item) {
      if (item.name === "home") {
        return this.$route.name === "home" || this.$route.name === "course-detail";
      }

      return this.$route.name === item.name;
    }
  }
};
</script>
